import React from "react";
import {
    Button,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { SizeAwareComponent } from "../../../store/types";

interface OwnProps extends SizeAwareComponent {
    onSave: () => void;
    isSaving: boolean;
};


const SaveButton = ({ isSaving, onSave, isMinimumSize }: OwnProps) => {
    return <Button
        colorScheme="green"
        variant={isMinimumSize ? "outline" : "ghost"}
        padding={isMinimumSize ? undefined : 0}
        margin={isMinimumSize ? undefined : 0}
        minWidth={isMinimumSize ? undefined : "5"}
        leftIcon={<FontAwesomeIcon icon={faSave} />}
        isLoading={isSaving}
        onClick={onSave}
        title="Guardar"
        iconSpacing={0}
    >
    </Button>;
}

export default SaveButton;
